// extracted by mini-css-extract-plugin
module.exports = {"eventos":"Eventos_eventos__3qB05"};